export const AmbassadorContentSecond = {
  SECOND_TITLE: 'championing positive vision',
  SECOND_ITEMS: [
    {
      image: 'bullet_one.svg',
      title: 'Mirror our ethos',
      description: 'Quality first, human centred, championing vision',
    },
    {
      image: 'bullet_two.svg',
      title: 'Reflect our brand values',
      description: 'Boldness, quality, optimism, transparency',
    },
    {
      image: 'bullet_three.svg',
      title: 'Help us map out the future of the eyecare industry ',
      description: 'Revolutionizing the eyecare industry, together ',
    },
  ],
  SECOND_CONTENT:
    'As a WALDO ambassador, you won’t just be a partner, you’ll become an extension of our brand and our voice.',
};
